import { render, staticRenderFns } from "./CommentsInclude.vue?vue&type=template&id=ca53c89e&scoped=true&"
import script from "./CommentsInclude.vue?vue&type=script&lang=js&"
export * from "./CommentsInclude.vue?vue&type=script&lang=js&"
import style0 from "./CommentsInclude.vue?vue&type=style&index=0&id=ca53c89e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca53c89e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca53c89e')) {
      api.createRecord('ca53c89e', component.options)
    } else {
      api.reload('ca53c89e', component.options)
    }
    module.hot.accept("./CommentsInclude.vue?vue&type=template&id=ca53c89e&scoped=true&", function () {
      api.rerender('ca53c89e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/newsletter/CommentsInclude.vue"
export default component.exports